import { LAYOUTS } from "../../_CORE/_RuntimeConfig/_Config/_Layouts.js";
import { DemoTemplatesViewerModule } from "./UI_TEST/_MODULES/DemoTemplatesViewerModule.js";

const DISPLAY_MODULE = (enabled, moduleFn) => (enabled ? moduleFn : () => []);

export const APP_MODULES = [
    DISPLAY_MODULE(LAYOUTS.IS_DEMO_TEMPLATE_MENU_ENABLED === true, DemoTemplatesViewerModule),
];

export const APP_MODULES_GET_PUBLIC_ROUTES = (dataUser = null, lang = "es") => (
    APP_MODULES.flatMap((moduleFn) => moduleFn(dataUser, lang))
        .filter((item) => item?.views === "PUBLIC")
);

export const APP_MODULES_GET_PRIVATE_ROUTES = (dataUser = null, lang = "es") => (
    APP_MODULES.flatMap((moduleFn) => moduleFn(dataUser, lang))
        .filter((item) => item?.views === "PRIVATE")
);

export const APP_MODULES_GET_ALL_ROUTES = (dataUser = null, lang = "es") => [
    ...APP_MODULES_GET_PUBLIC_ROUTES(dataUser, lang),
    ...APP_MODULES_GET_PRIVATE_ROUTES(dataUser, lang),
];
